module.exports = __webpack_public_path__ + "static/media/selectedPlaneStopIcon.f5b86f0a.png";